// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusCircleTwoToneSvg from "@fishx/icons-svg/es/asn/PlusCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var PlusCircleTwoTone = function PlusCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleTwoToneSvg
  }));
};

PlusCircleTwoTone.displayName = 'PlusCircleTwoTone';
export default React.forwardRef(PlusCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlusCircleTwoTone.js
// module id = 3820
// module chunks = 0